import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-instructions-qr-code',
  templateUrl: './modal-instructions-qr-code.component.html',
  styleUrls: ['./modal-instructions-qr-code.component.scss']
})
export class ModalInstructionsQrCodeComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  onNoClick(): void {
    this.dialog.open(ModalInstructionsQrCodeComponent);
  }

  ngOnInit(): void {}

}